import DatricRequests from '../datric.requests';
import { CreateIndicatorPayload, Indicator, UpdateIndicatorPayload } from '../../../models/indicator.model';

const requests = new DatricRequests();

export async function listIndicators(): Promise<Indicator[]> {
	return requests.get('indicators');
}

export async function createIndicator(payload: CreateIndicatorPayload): Promise<Indicator> {
	return requests.post('indicators', payload);
}

export async function updateIndicator(id: string, payload: UpdateIndicatorPayload): Promise<Indicator> {
	return requests.patch(`indicators/${id}`, payload);
}

export async function setIndicatorActive(id: string, active: boolean): Promise<Indicator> {
	return requests.patch(`indicators/${id}/active`, { active });
}

export async function deleteIndicator(id: string): Promise<{ success: boolean }> {
	return requests.delete(`indicators/${id}`);
}
